import {AxiosResponse} from "axios";
import axios from "../utils/axios";
import {LogEntryQuery} from "../models/LogEntry";

export const fetchLogsByObjectId = (token: string, objectId: string, page: number, limit: number = 5) => {
  let offset = (page - 1) * limit;
  return new Promise<AxiosResponse<LogEntryQuery>>((resolve, reject) => {
    axios
      .get(`${process.env.REACT_APP_API_DOMAIN}/logs_entry/?object_id=${objectId}&limit=${limit}&offset=${offset}`, {
        headers: { Authorization: "Token " + token },
      })
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}